import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  modal: { overflowY: 'auto' },
  paper: {
    backgroundColor: theme.palette.background.default,
    margin: 'auto',
    width: '60%',
    maxWidth: 700,
    padding: 24,
    marginTop: '15vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 15
  },
  inputContainer: {
    marginTop: 40,
    display: 'grid',
    alignItems: 'center',
    columnGap: 30,
    gridTemplateColumns: 'repeat(2,1fr)',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 8
  },
  policyIcon: {
    margin: 'auto',
    fontSize: 80,
    position: 'absolute',
    backgroundColor: theme.palette.type === 'dark' ? '#212121' : '#7f7f7f',
    padding: 10,
    borderRadius: '50%',
    top: -42,
    color: theme.palette.primary.main,
    left: 'calc(50% - 40px)'
  },
  interval: { display: 'grid', gridTemplateRows: '3fr 1fr', rowGap: 0 },
  switchContainerActive: {
    flex: 0.65,
    marginLeft: 10,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      textAlign: 'left',
      padding: '0 10px'
    }
  },
  switch: {
    width: 'auto',
    display: 'flex',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  selectStateSelector: {
    marginRight: 100,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      marginRight: 59
    }
  },
  selectStateSelectorlabel: {
    marginRight: 100,
    [theme.breakpoints.down('sm')]: {
      marginRight: 59
    }
  },
  stateRadioGroup: {
    display: 'flex',
    flexDirection: 'column'
  }
  // endpoint: {
  //   textAlign: 'right'
  // }
}))
export default useStyles
